/* eslint-disable react/prop-types */ // TODO: add props
import React from 'react';
import cx from 'classnames';
import styles from './LessonProgressHeaderRow.scss';
import { Table } from 'edrolo/domains/teacherResultsTable';
import {
  getGuidingQuestionGroupChunks,
  getGuidingQuestionLastChunkIds,
  getNonGuidingQuestionChunkIds,
} from '../../utils';

const EmptyHeaderCell = () => (
  <Table.ColHeader
    className={cx(styles.colHeader, styles.emptyHeaderCells)}
    isSticky
  />
);

const LessonProgressSuperHeaderRow = React.memo(
  ({ chunks, shouldShowStudentNotes }) => {
    let chunkHeaders = [];

    // Used for inserting and styling super-headers for guiding question chunks
    const guidingQuestionLastChunkIds = getGuidingQuestionLastChunkIds(chunks);
    const lastGuidingQuestionLastChunkId = guidingQuestionLastChunkIds.last();

    // Used for inserting EmptyHeaderCells for non-guiding question chunks
    const nonGuidingQuestionChunkIds = getNonGuidingQuestionChunkIds(chunks);

    // Used for working out super-header's 'ColSpan' spanning guiding question chunks
    const guidingQuestionGroupChunks = getGuidingQuestionGroupChunks(chunks);

    // This way of arranging EmptyHeaderCells and SuperHeaders allow for
    // proper alignment with sub-headers and chunk indicator cells
    chunks.forEach((chunk) => {
      if (nonGuidingQuestionChunkIds.includes(chunk.get('id'))) {
        chunkHeaders.push(<EmptyHeaderCell />);
      } else if (guidingQuestionLastChunkIds.includes(chunk.get('id'))) {
        const colSpan = guidingQuestionGroupChunks.find((chunkGroup) =>
          chunkGroup.some((c) => c.get('id') === chunk.get('id'))
        ).size;
        // IT's unlikely that 'success_measure' is not populated, but just incase™️
        const guidingQuestionText = chunk.getIn(
          ['success_measure', 'guiding_question_text'],
          ''
        );

        // XXX: colspan is not enough, need to finetune the width dynamically
        const maxWidthOfFirstGroupedChunk = 38;
        const maxWidthOfLastGroupedChunk = 87;
        const maxWidthOfMiddleGroupedChunks = 29;
        const numMiddleGroupedChunks = colSpan - 2; // 2 => first chunk and last chunk
        const superheaderMaxWidth =
          numMiddleGroupedChunks * maxWidthOfMiddleGroupedChunks +
          maxWidthOfFirstGroupedChunk +
          maxWidthOfLastGroupedChunk;

        chunkHeaders.push(
          <Table.ColHeader
            className={cx(
              styles.colHeader,
              styles.successMeasureGroupChunksHeader,
              {
                [styles.lastGuidingQuestionLastChunk]:
                  lastGuidingQuestionLastChunkId === chunk.get('id'),
              }
            )}
            isSticky
            colSpan={colSpan}
            data-test="success-measure-super-header"
            style={{
              maxWidth: `${superheaderMaxWidth}px`,
            }}
            title={guidingQuestionText}
          >
            {guidingQuestionText}
          </Table.ColHeader>
        );
      }
    });

    return (
      <Table.Row className={styles.headerRow}>
        {/** Ensure number of <EmptyHeaderCell /> used below matches number of non-chunk columns in <LessonProgressHeaderRow /> */}
        <EmptyHeaderCell />
        <EmptyHeaderCell />
        <EmptyHeaderCell />
        {shouldShowStudentNotes && <EmptyHeaderCell />}
        {chunkHeaders}
      </Table.Row>
    );
  }
);

export default LessonProgressSuperHeaderRow;
